class BricksOnSaleSummary {
    retailPrice;
    available;
    maximumToPurchase;
    sellingByInvestor;
    totalPropertyBricks;
    items;
    lowestPrice;
    highestPrice;
    averagePrice;
    constructor(data) {
        this.lowestPrice = data.lowestPrice;
        this.highestPrice = data.highestPrice;
        this.averagePrice = data.averagePrice;
        this.retailPrice = data.retailPrice;
        this.available = data.available;
        this.maximumToPurchase = data.maximumToPurchase;
        this.sellingByInvestor = data.sellingByInvestor;
        this.totalPropertyBricks = data.totalPropertyBricks;
        this.items = data.items;
    }
}
export default BricksOnSaleSummary;
